module.exports = __webpack_public_path__ + "img/1f974.9e681f0.svg";